import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/events/halloween/floating/icon-float-close.webp")